/**
 * Function for converting basic text into chemical formula
 * @example tokenize('CH4') // => CH₄
 */
export const tokenize = (formula: string) =>
  formula
    .split(/(\d+)/)
    .map((token: string, idx: number) =>
      idx % 2 ? <sub key={idx}>{token}</sub> : token,
    );
